import {
  type CommandAction,
  useCommandRegistry as useCommandRegistryContext
} from '@/context/CommandRegistryContext'
import { useEffect } from 'react'

/** Re-export the context hook. */
export { useCommandRegistry } from '@/context/CommandRegistryContext'
export type { CommandAction }

/** Convenience: register actions for the lifetime of a component. */
export function useRegisterCommands(actions: CommandAction[]) {
  const { register } = useCommandRegistryContext()
  useEffect(() => {
    return register(actions)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [
    register,
    JSON.stringify(actions.map((a) => ({ id: a.id, label: a.label })))
  ])
}
